export const MockRegos = [
  { value: 'abc123', label: 'abc123' },
  { value: '234232', label: '234232' },
  { value: '3453034', label: '3453034' }
];
export const MockProviders = [
  { value: 'Caltex', label: 'Caltex' },
  { value: 'BHP', label: 'BHP' },
  { value: 'Shell', label: 'Shell' }
];



// WEBPACK FOOTER //
// ./src/features/fuel-cards/order-fuel-card/mockRows.js